
import React, {FC} from 'react';

import Content, {ContentProps} from './Content';
import Heading, {HeadingProps} from './Heading';

export type TabProps = {
	children: [
		React.ReactElement<HeadingProps>,
		React.ReactElement<ContentProps>,
	]
};

// Tab is just a wrapper that defines its types
// for configuration; all render is done in "Tabs"
const Tab: FC<TabProps> = () => null;

export default Object.assign(Tab, {
	Content,
	Heading,
});
